import React from 'react';

export const FolderPrimaryIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M18.3332 9.16667V15.8333C18.3333 16.2538 18.1745 16.6588 17.8886 16.9671C17.6027 17.2754 17.2108 17.4643 16.7915 17.4958L16.6665 17.5H3.33317C2.91269 17.5001 2.5077 17.3413 2.19938 17.0554C1.89106 16.7695 1.70221 16.3776 1.67067 15.9583L1.6665 15.8333V9.16667H18.3332ZM7.93317 2.5C8.1576 2.49999 8.37972 2.5453 8.58621 2.63322C8.7927 2.72115 8.97931 2.84987 9.13484 3.01167L9.23484 3.12583L10.3998 4.58333H16.6665C17.087 4.5832 17.492 4.74201 17.8003 5.02791C18.1086 5.31382 18.2975 5.7057 18.329 6.125L18.3332 6.25V7.5H1.6665V4.16667C1.66637 3.74619 1.82518 3.34119 2.11108 3.03288C2.39699 2.72456 2.78887 2.5357 3.20817 2.50417L3.33317 2.5H7.93317Z"
        fill="#774EFF"
      />
    </svg>
  );
};
